import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {User} from '../../../data/models/user';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MeService} from '../../../services/api/me.service';
import {USER_VALIDATORS} from '../../../../constants/validators';

@Component({
  selector: 'app-me-change-password-dialog',
  templateUrl: './me-change-password-dialog.component.html',
  styleUrls: ['./me-change-password-dialog.component.css']
})
export class MeChangePasswordDialogComponent implements OnInit {

  public user: User;
  public passwordForm: FormGroup;
  public passwordHide = true;

  @ViewChild('currentPasswordInput') currentPasswordInputElement!: ElementRef;

  constructor(
    private meService: MeService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<MeChangePasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      user: User,
    },
  ) {
    this.user = this.data.user;
    this.passwordForm = this.fb.group({
      currentPassword: ['', [Validators.required]],
      password: ['', USER_VALIDATORS.PASSWORD],
    });
  }

  ngOnInit(): void {
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.passwordForm.valid) {
      this.meService.changePassword(
        this.passwordForm.controls.currentPassword.value,
        this.passwordForm.controls.password.value)
        .then(user => this.dialogRef.close(user))
        .catch(error => {
          if (error.error?.fields?.currentPassword) {
            this.passwordForm.controls.currentPassword.setValue('');
            this.passwordForm.controls.currentPassword.setErrors({wrong: true});
            setTimeout(() => {
              this.currentPasswordInputElement.nativeElement.focus();
            }, 0);
          }
        });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
